var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box-2"},[_c('div',{staticClass:"pillar"},[_vm._t("default")],2),_vm._v(" "),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }